<template>
    <div v-if="display" :class="className()">
        <div id="background"></div>
        <div id="content">
            <div>
                <div id="wrapper">
                  <svg class="close" v-on:click="hide" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m14.1225324 12.0002502 9.4377019-9.43809548c.5863543-.58587837.5863543-1.53649231 0-2.12237069-.5863542-.58637871-1.5359279-.58637871-2.1222822 0l-9.4377019 9.43809543-9.4382023-9.43809543c-.58635425-.58637871-1.53592795-.58637871-2.12228221 0-.58635425.58587838-.58635425 1.53649232 0 2.12237069l9.43820225 9.43809548-9.43820225 9.4380954c-.58635425.5858784-.58635425 1.5364923 0 2.1223707.29317713.292689.67740927.4392837 1.06114111.4392837s.76796398-.1465947 1.0611411-.439784l9.4382023-9.4380955 9.4377019 9.4380955c.2931771.2931893.6774093.439784 1.0611411.439784s.767964-.1465947 1.0611411-.439784c.5863543-.5858784.5863543-1.5364923 0-2.1223707z" fill-rule="evenodd"/></svg>
                  <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    dark: Boolean,
    noWrapper: Boolean,
    unclosable: Boolean
  },
  data () {
    return {
      display: false
    }
  },
  methods: {
    show () {
      this.display = true
    },
    showing () {
      return this.display
    },
    hide () {
      this.$emit('hide')
      this.display = false
    },
    className () {
      var classes = ['modal']
      if (this.dark) classes.push('dark')
      else classes.push('light')
      if (this.noWrapper) classes.push('no-wrapper')
      if (this.unclosable) classes.push('unclosable')
      return classes.join(' ')
    }
  }
}
</script>

<style scoped>

.modal {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 20;
}

.modal.light {
    color: #000000;
}

.modal.dark {
    color: #ffffff;
}

#background {
    background: #000000;
    height: 100%;
    left: 0;
    opacity: 0.7;
    position: absolute;
    top: 0;
    width: 100%;
}

#content {
    display: table;
    height: 100%;
    position: relative;
    width: 100%;
}

#content > div {
    display: table-cell;
    height: 100%;
    text-align: center;
    vertical-align: middle;
    width: 100%;
}

#wrapper {
    border-radius: 1em;
    display: inline-block;
    margin: auto;
    max-width: 75%;
    padding: 4em 2em 2em 2em;
    position: relative;
}

.light #wrapper {
    background-color: #ffffff;
}

.dark #wrapper {
    background-color: #323232;
}

#wrapper .close {
    cursor: pointer;
    position: absolute;
    right: 1em;
    top: 1em;
    width: 1em;
}

.light .close path {
  fill: #000000;
}

.dark .close path {
  fill: #ffffff;
}

.modal.unclosable #wrapper {
    padding: 2em;
}

.modal.no-wrapper #wrapper .close, .modal.unclosable #wrapper .close {
  display: none;
}

.modal.no-wrapper #wrapper {
  background-color: transparent;
  padding: 0;
}

</style>

<style>

.modal .title {
  font-size: 1.8em;
}

.modal form {
  color: rgba(0, 0, 0, 0.4);
  width: 100%;
}

</style>
